import React from 'react';
import { AuthDelegate } from '../utils';

// This class is meant to be abstract.  If you want to toggle elements in a view, use AuthToggle.
class AuthComponent extends React.Component {

    constructor(props){
        super(props);
        if (!props.user) {
            throw new Error('AuthComponent must always be passed prop \'user\'.');
        }

        this.userSafe = false;

        this.authorized = false;
    }

    componentWillMount() {
        this.userDidLoad(this.props.user);
    }

    componentWillReceiveProps(props) {
        this.userDidLoad(props.user);
    }

    //fires only once when the user is authorized.
    userDidAuthorize() {

    }

    userDidLoad(user) {
        this.userSafe = true;

        switch (this.userIsAuthorized(user)) {
            case AuthDelegate.authStates.AUTHORIZED:
                if (!this.authorized) {
                    this.authorized = true;
                    this.userDidAuthorize(user);
                }
                this.componentWillAcceptUser(user);
                break;
            case AuthDelegate.authStates.UNAUTHORIZED:
                this.authorized = false;
                this.componentWillRejectUser(user);
                break;
            case AuthDelegate.authStates.DEFERRED:
                this.authorized = false;
                this.componentWillDeferUser(user);
                break;
            default:
                console.error('Invalid Auth State returned from userIsAuthorized.  Rejecting the user.');
                this.componentWillRejectUser(user);
                break;
        }
    }

    userIsAuthorized(user){
        return AuthDelegate.userIsLoggedIn()(user);
    }

    componentWillRejectUser(){

    }

    componentWillDeferUser(){

    }

    componentWillAcceptUser(){

    }

    rejectRender() {
        return null;
    }

    authRender() {
        return null;
    }

    deferRender() {
        return null;
    }

    render () {
        if (!this.userSafe) {
            console.error('Warning: user methods were not called on AuthComponent. Did you forget to call super in componentWillMount or componentWillReceiveProps?');
        }
        switch (this.userIsAuthorized(this.props.user)) {
            case AuthDelegate.authStates.AUTHORIZED:
                return this.authRender();
            case AuthDelegate.authStates.UNAUTHORIZED:
                return this.rejectRender();
            case AuthDelegate.authStates.DEFERRED:
                return this.deferRender();
            default:
                return this.rejectRender();
        }
    }
}

export default AuthComponent;



// WEBPACK FOOTER //
// ./web-app/components/auth-component.js